import { render, staticRenderFns } from "./network-detail.vue?vue&type=template&id=48620e6d&scoped=true&"
import script from "./network-detail.vue?vue&type=script&lang=js&"
export * from "./network-detail.vue?vue&type=script&lang=js&"
import style0 from "./network-detail.vue?vue&type=style&index=0&id=48620e6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48620e6d",
  null
  
)

export default component.exports